/**
 * user-media コンポーネント専用i18n定数
 */

export const USER_MEDIA_I18N = {
  // パンくずリスト
  breadcrumb: {
    userList: $localize`:@@home.userMedia.breadcrumb.userList:ユーザー一覧`,
    media: $localize`:@@home.userMedia.breadcrumb.media:メディア`,
  },

  // ファイル選択
  file: {
    notSelected: $localize`:@@home.userMedia.file.notSelected:［ファイル未選択］`,
    selectBeforeUpload: $localize`:@@home.userMedia.file.selectBeforeUpload:送信の前に、アップロードするファイルを選択してください`,
    unsupportedFormat: $localize`:@@home.userMedia.file.unsupportedFormat:選択されたファイルの形式はサポートされていません`,
  },

  // 種別
  type: {
    selectType: $localize`:@@home.userMedia.type.selectType:種別を選択してください`,
  },

  // アップロード
  upload: {
    complete: $localize`:@@home.userMedia.upload.complete:ファイルのアップロードが完了しました。`,
    failed: $localize`:@@home.userMedia.upload.failed:ファイルのアップロードが失敗しました。`,
    encodingStarted: $localize`:@@home.userMedia.upload.encodingStarted:ファイルのエンコーディングを開始しました。完了までお待ち下さい`,
  },

  // 削除
  delete: {
    title: $localize`:@@home.userMedia.delete.title:メディアの削除`,
    confirmMessage: $localize`:@@home.userMedia.delete.confirmMessage:このメディアを本当に削除しますか？`,
    success: $localize`:@@home.userMedia.delete.success:選択されたメディアを削除しました`,
  },

  // 検索
  search: {
    placeholder: $localize`:@@home.userMedia.search.placeholder:検索`,
    inputPlaceholder: $localize`:@@home.userMedia.search.inputPlaceholder:コメント・種別で検索`,
  },

  // ビュー切替
  view: {
    gallery: $localize`:@@home.userMedia.view.gallery:ギャラリー表示`,
    list: $localize`:@@home.userMedia.view.list:リスト表示`,
  },

  // リストカラム
  list: {
    createdAt: $localize`:@@home.userMedia.list.createdAt:作成日時`,
    mediaType: $localize`:@@home.userMedia.list.mediaType:メディア`,
    method: $localize`:@@home.userMedia.list.method:種別`,
    comment: $localize`:@@home.userMedia.list.comment:コメント`,
    status: $localize`:@@home.userMedia.list.status:ステータス`,
  },

  // ボタン
  button: {
    close: $localize`:@@home.userMedia.button.close:閉じる`,
    refresh: $localize`:@@home.userMedia.button.refresh:更新`,
  },
} as const;

export type UserMediaI18n = typeof USER_MEDIA_I18N;
